<template>
  <div>
    <div class="bg-dark m-b-30">
      <div class="container">
        <div class="row p-b-60 p-t-60">
          <div class="col-md-6 text-white p-b-30">
            <div class="media">
              <div class="avatar avatar mr-3">
                <div class="avatar-title bg-success rounded-circle mdi mdi-star-circle"></div>
              </div>
              <div class="media-body">
                <h3 class="p-t-10">{{ pageTitle || $t('loyalty.name') }}</h3>
                <p class="opacity-75">{{ $t('loyalty.title.dashboard') }}</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 text-center m-b-30 ml-auto">
            <div class="text-md-right">
              <slot name="header-actions">
                <button
                  v-if="headerAction"
                  type="button"
                  class="el-button el-button--info el-button--medium"
                  @click="handleHeaderAction">
                  <i v-if="headerAction.icon" :class="headerAction.icon"></i> {{ headerAction.label }}
                </button>
              </slot>
              <router-link :to="{name: 'loyalty-programs'}" class="el-button el-button--primary el-button--medium">
                <i class="mdi mdi-format-list-bulleted"></i> {{ $t('loyalty.button.all') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <router-view
        @parent-title="updateTitle"
        @set-header-action="setHeaderAction"
        @clear-header-action="clearHeaderAction"/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Loyalty',
  data () {
    return {
      pageTitle: this.$t('loyalty.name'),
      headerAction: null
    }
  },
  methods: {
    updateTitle (title) {
      this.pageTitle = title
    },
    setHeaderAction (action) {
      this.headerAction = action
    },
    clearHeaderAction () {
      this.headerAction = null
    },
    handleHeaderAction () {
      if (!this.headerAction) return
      if (typeof this.headerAction.onClick === 'function') {
        this.headerAction.onClick()
        return
      }
      if (this.headerAction.route) {
        this.$router.push(this.headerAction.route)
        return
      }
      this.$router.back()
    }
  },
  watch: {
    $route () {
      this.clearHeaderAction()
    }
  }
}
</script>

<style scoped>
</style>
